const getTrafxEntries = (state) =>{
    return state.entries
}

const getTrafxFiles = (state) =>{
    return state.files
}

const getCurrentTrafxData = (state) =>{
    return state.current_trafx_data
}

const getIsLoading = (state) =>{
    return state.isLoading
}

const getFilesSerialNumbers = (state) =>{
    return state.files.map(function(val, idx){ return val.serial })
}

const getFilesRecords = (state) =>{
    return state.files.map(function(val, idx){ return val.records })
}

export default {
    getTrafxEntries,
    getTrafxFiles,
    getCurrentTrafxData,
    getIsLoading,
    getFilesSerialNumbers,
    getFilesRecords,
}